import { render, staticRenderFns } from "./Contrato.vue?vue&type=template&id=50e5cf1c"
import script from "./Contrato.vue?vue&type=script&lang=js"
export * from "./Contrato.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ovilla/Documents/strappberry/catara-server/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50e5cf1c')) {
      api.createRecord('50e5cf1c', component.options)
    } else {
      api.reload('50e5cf1c', component.options)
    }
    module.hot.accept("./Contrato.vue?vue&type=template&id=50e5cf1c", function () {
      api.rerender('50e5cf1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/wizardUser/Contrato.vue"
export default component.exports